<template>
	<div class="container">
		<div v-if="venue_data" class="row">
			<div class="col-12 col-lg-6">
				<div class="container p-0 m-0">
					<div class="row">
						<div v-for="(score_data, group) in venue_data.scores" class="col-4 col-sm-4">
							<stats-card
								:label="group"
								:value="score_data.score"
								:max_score="score_data.max_group_score"
								:last_label="last_label ? last_label : 'Previous'"
								:improved_by="score_data.improved_by"
							></stats-card>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6 p-0">
				<radial-graph
					:graph_data="venue_data.scores"
					:subtitle_1="radial_subtitle_1"
					:subtitle_2="radial_subtitle_2"
					@update_graph_image="(data) => $emit('update_graph_image', data)"
				></radial-graph>
			</div>
		</div>
	</div>
</template>

<script>
	import RadialGraphComponent from './RadialGraphComponent.vue';
	import StatsNumberCardComponent from './StatsNumberCardComponent.vue'

	export default {
		components:{
			'radial-graph': RadialGraphComponent,
			'stats-card': StatsNumberCardComponent
		},

		props:[
			'venue', 'venue_data', 'last_label', 'radial_subtitle_1', 'radial_subtitle_2'
		],

		mounted() {

		},

		methods: {

		},

		watch: {
			venue(){

			}
		}
	}
</script>
